// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"8d58a32b405c46d4f03a576cda12d99c3167984d"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/ariza/assets/production-20250610102551-8d58a32b405c46d4f03a576cda12d99c3167984d";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.sentryDsn,
  enabled: process.env.NODE_ENV !== "test",
  release: process.env.sentryRelease,
  ignoreErrors: [],
});
